import React, { useContext, useEffect } from 'react'
import { useLocation } from 'react-router-dom';
import { Update } from '../../App';
import { Box, CardContent } from '@mui/material';

const Diet = () => {
  const location=useLocation()
  const {setDisplayAppBar}=useContext(Update)
  useEffect(() => {
    if (location.pathname === "/gym/gymdiet") {
      setDisplayAppBar("none");
    }
    // console.log()
  }, []);
  return (
<Box sx={{display:"flex",justifyContent:"center",mt:{xs:"20%",lg:"10%"}}}>
      <CardContent sx={{transform:"rotate(-10deg)",fontSize:{xs:"34px",md:"44px"},fontWeight:"bold",}}>
      Development Mode
      </CardContent>
    </Box>
  )
}

export default Diet